export var decodeJWTTokenPayload = function decodeJWTTokenPayload(token) {
  return JSON.parse(atob(token.split(".")[1]));
};